import React, { PureComponent, Fragment } from 'react';
import OrderPanel from '../containers/OrderPanel';
import Player from '../containers/Player';
import './page.css';

export default class OrderPage extends PureComponent {
  render() {
    return (
      <Fragment>
        <div id="orderPlayerRoot">
          <Player />
        </div>
        <div id="orderUiRoot">
          <OrderPanel />
        </div>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/OrderPage.js